<template>
  <div class="v-empty-state">
    <div class="v-empty-state-container">
      <template v-if="icon">
        <v-icon class="v-empty-state-icon">{{ icon }}</v-icon>
      </template>
      <strong class="v-empty-state-label" v-if="label">{{ label }}</strong>
      <p class="v-empty-state-description" v-if="description">
        {{ description }}
      </p>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'v-empty-state',
  props: {
    size: {
      type: Number,
      default: 420
    },
    icon: String,
    label: String,
    description: String
  }
}
</script>

<style scoped lang="scss">
@import '@argon/vue-cli-plugin-vuetify-preset/preset/_mixins';

@mixin v-empty-state-base() {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.v-empty-state {
  @include v-empty-state-base();
  max-width: 600px;
  padding: 36px;
  margin: 0 auto;
  position: relative;
}

.v-empty-state-enter {
  opacity: 0;
  transform: scale(0.87);

  .v-empty-state-container {
    opacity: 0;
  }
}

.v-empty-state-container {
  @include v-empty-state-base();
}

.v-empty-state-icon {
  @include v-icon-size(160px);
  margin: 0 0 30px 0;
}

.v-empty-state-label {
  font-size: 26px;
  font-weight: 500;
  line-height: 40px;
}

.v-empty-state-description {
  margin: 1em 0;
  font-size: 16px;
  line-height: 24px;
}
</style>
